<meta charset="utf-8">

<h4>Competiciones</h4>

<p>
    <select id="temporada" name="temporada" class="form-control" (change)="selectTemporadaChangeHandler($event)">
       <option [value]="temporada.id" *ngFor="let temporada of temporadas">{{temporada.nombre}}</option>
    </select>
</p>


<p>
    <select id="equipo" name="equipo" class="form-control" (change)="selectEquipoChangeHandler($event)">
       <option [value]="equipo.id" *ngFor="let equipo of equipos">{{equipo.nombre}}</option>
    </select>
</p>

<!--  -->

<button *ngIf="editable" class="btn btn-primary" (click)="clickAddCompeticion()">Añadir competicion</button>

<table class="table table-striped" *ngIf="competiciones && competiciones.length > 0">
  <thead>
    <tr>
      <th>Nombre</th>
      <th></th>
    </tr>
  </thead>
  <tbody>
    <tr *ngFor="let competicion of competiciones, let index = index">
      <td>{{competicion.nombre}}</td>
      <td><button *ngIf="editable" class="btn btn-primary btn-edit" (click)="handleEditClick(competicion)">Editar</button></td>
    </tr>
  </tbody>
</table>